import React from 'react';
import Toggle from 'elements/Forms/components/Toggle';
import styles from './style/listItem.module.css';

interface ToggleItemProps {
  borderInset?: number | string,
  checked: boolean,
  handler: Function,
  label: string,
  name: string,
  value: string,
}

function ToggleItem({
  borderInset,
  checked,
  handler,
  label,
  name,
  value,
}:ToggleItemProps) {
  return (
    <button
      className={styles.listItem}
      data-border-inset={borderInset}
      name={name}
      onClick={() => handler()}
      type="button"
      value={value}
    >
      { label }
      <Toggle active={checked} />
    </button>
  );
}

ToggleItem.defaultProps = {
  borderInset: '',
}

export default ToggleItem;
